/**
 * Stacks a popover, menu or tooltip above the output modal, whose backdrop
 * sits at `z-100` (`PreviewLayover/Overlay`). Anything opened from inside the
 * modal needs it, or it opens behind the backdrop.
 *
 * @remarks
 * Lives in `@/shared` because both `@/modules/outputs` (which owns the modal)
 * and `@/modules/idp` (whose panel is drawn inside it) need it.
 */
export const ABOVE_OUTPUT_MODAL_CLASSNAME = 'z-101';
